require('./vehicle-dropdown.scss');

import { selectVehicle, updateQueryAfterVehicleChange } from '../../core/actions/vehicles';
import { queryParamsLoaded } from '../../core/actions/data';
import { getAllVehicles, getSelectedVehicle } from '../../core/selectors/vehicles';
riot.tag2('vehicle-dropdown', '<div class="vehicle-dropdown"> <h2 class="acr-label-2">{getLabel(\'labels.global.dropdownTitle\')}</h2> <div class="vehicle-dropdown-container"> <select name="input-vehicle" id="input-vehicle" class="vehicle-dropdown-select" data-automation="vehicle-dropdown-select" onchange="{changeVehicle}"> <option class="acr-caption-12" riot-value="{labels.global.dropdown}">{getLabel(\'labels.global.dropdown\')}</option> <option class="acr-caption-12" each="{vehicle in vehicles}" riot-value="{vehicle.model+\',\'+vehicle.year}" is-selected="{vehicle.selected ? \'selected\' : \'\'}">{vehicle.model}</option> </select> </div> </div>', '', '', function(opts) {

    const self = this;
    const trackingJSON = require('../../data/tracking-data');

    window.Acr = window.Acr ? window.Acr : {};

    self.trackingData = trackingJSON.default.selectAVehicle;

    self.mixin('redux');
    self.mixin('bus');

    self.subscribe(getAllVehicles);
    self.subscribe(getSelectedVehicle);
    self.dispatchify({ selectVehicle });
    self.dispatchify({ updateQueryAfterVehicleChange });
    self.dispatchify({ queryParamsLoaded });

    function getTrackingData(model) {
      const jsonData = JSON.parse(JSON.stringify(self.trackingData));
      jsonData.dynamic_variables[0].search += model;
      if (window.Acr.TrackingManager) {
        window.Acr.TrackingManager.clickActivity(jsonData);
      }
    }

    function changeVehicle() {
      const $input = self['input-vehicle'];

      self.currentValue = $input.value.split(',');
      self.selectVehicle({ model: self.currentValue[0] });
      self.updateQueryAfterVehicleChange({ model: self.currentValue[0] });
      self.queryParamsLoaded({ defaultModelGroup: self.currentValue[0] });

      self.bus.trigger(self.bus.EVENTS.MODEL.CHANGE, { newValue: self.currentValue[0] });
      getTrackingData(self.currentValue[0]);
    }

    self.changeVehicle = changeVehicle;

    self.on('mount', () => {
      self.currentValue = self['input-vehicle'].value;
    });
});
